import { render } from "./AccountUpdateLanguage.vue?vue&type=template&id=025c7d22&scoped=true"
import script from "./AccountUpdateLanguage.vue?vue&type=script&lang=js"
export * from "./AccountUpdateLanguage.vue?vue&type=script&lang=js"

import "./AccountUpdateLanguage.vue?vue&type=style&index=0&id=025c7d22&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/ADP_CashParis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-025c7d22"]])

export default __exports__